export const ASSISTANT_DOCK_MIN = 340;
export const ASSISTANT_DOCK_DEFAULT = 420;
export const ASSISTANT_DOCK_MAX = 650;
export const ASSISTANT_DOCK_MQ = '(min-width: 1024px)';
export const ASSISTANT_DOCK_WIDTH_KEY = 'signalbridge.assistant.dockWidth';
export const ASSISTANT_DOCK_CSS_VAR = '--sb-assistant-dock-width';

const API_PIN_KEYS = [
  'flowId',
  'flowRunId',
  'deviceId',
  'agentId',
  'zoneId',
  'kind',
  'segmentId',
  'callSid',
  'commandId',
  'sessionId',
  'sipPagingCallId',
  'triggerId',
  'notificationId',
  'actionId',
  'timeRange',
  'executionStatus',
  'errorCode',
  'failedStep',
];

export function apiPins(pins = {}) {
  const out = {};
  for (const key of API_PIN_KEYS) {
    if (pins[key] == null || pins[key] === '') continue;
    out[key] = pins[key];
  }
  return out;
}

export function describeAssistantContext(pins = {}) {
  const api = apiPins(pins);
  if (!Object.keys(api).length && !pins.label && !pins.name) return null;
  let type = 'Page';
  if (api.flowRunId) type = 'Flow Run';
  else if (api.flowId) type = 'Flow';
  else if (api.deviceId) type = 'Device';
  else if (api.agentId) type = 'Agent';
  else if (api.kind === 'sip') type = 'SIP Paging Zone';
  else if (api.kind === 'rtp') type = 'RTP Paging Zone';
  else if (api.zoneId) type = 'Paging Zone';
  const name = pins.label || pins.name || api.flowId || api.deviceId || api.agentId || api.zoneId || '';
  return { name, type };
}

export function clampDockWidth(value) {
  const width = Math.round(Number(value));
  if (!Number.isFinite(width)) return ASSISTANT_DOCK_DEFAULT;
  return Math.min(ASSISTANT_DOCK_MAX, Math.max(ASSISTANT_DOCK_MIN, width));
}

export function loadDockWidth() {
  try {
    return clampDockWidth(localStorage.getItem(ASSISTANT_DOCK_WIDTH_KEY) || ASSISTANT_DOCK_DEFAULT);
  } catch {
    return ASSISTANT_DOCK_DEFAULT;
  }
}

export function saveDockWidth(width) {
  try {
    localStorage.setItem(ASSISTANT_DOCK_WIDTH_KEY, String(clampDockWidth(width)));
  } catch {
    /* ignore quota / private mode */
  }
}

export function applyDockWidthVar(px) {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty(ASSISTANT_DOCK_CSS_VAR, px > 0 ? `${Math.round(px)}px` : '0px');
}

export function isAssistantHomePath(pathname) {
  const path = String(pathname || '');
  return path === '/' || path === '/home' || path === '/home/' || path.startsWith('/home/');
}

export const TROUBLESHOOT_STARTER = 'What failed, and how do I fix it?';
export const ASK_PLACEHOLDER = 'Ask how to set something up, or what went wrong…';

export function inferAssistantMode(text, { canSetup = false, canTroubleshoot = false } = {}) {
  const q = String(text || '').toLowerCase();
  const looksTroubleshoot = /\b(fail|failed|broken|error|why did|not working|didn't|did not|fix this|troubleshoot|what went wrong)\b/.test(q);
  const looksSetup = /\b(how do i|how to|set up|configure|create a|create an|add a|add an|install|publish|pair)\b/.test(q);
  if (looksTroubleshoot && canTroubleshoot) return 'troubleshoot';
  if (looksSetup && canSetup) return 'setup';
  if (canTroubleshoot) return 'troubleshoot';
  if (canSetup) return 'setup';
  return 'troubleshoot';
}
